export class SummaryInvoiceAutoDebitSearchCriteria {
  constructor() {
    //this.month = null;
    this.segmentDetails = "";
  }

  month!: Date;
  segmentDetails: string;
}
